export default __webpack_public_path__ + "static/media/local_atm.4eec6a74.svg";